import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = [
    {
      title: '热门分类',
      links: [
        { label: '明星八卦', to: '/category/mingxing-bagua' },
        { label: '网红爆料', to: '/category/wanghong-baoliao' },
        { label: '社会热点', to: '/category/shehui-redian' },
        { label: '娱乐综艺', to: '/category/yule-zongyi' },
      ],
    },
    {
      title: '更多栏目',
      links: [
        { label: '影视剧情', to: '/category/dianshi-juqing' },
        { label: '黑料实锤', to: '/category/heike-liao' },
        { label: '关于我们', to: '/about' },
        { label: '最新文章', to: '/' },
      ],
    },
    {
      title: '友情链接',
      links: [
        { label: '吃瓜视频', to: '/' },
        { label: '今日黑料', to: '/' },
        { label: '网红动态', to: '/' },
        { label: 'App下载', to: '/#download' },
      ],
    },
  ];

  const socialLinks = [
    { icon: 'ri-weibo-line', label: '微博', href: '#' },
    { icon: 'ri-wechat-line', label: '微信', href: '#' },
    { icon: 'ri-tiktok-line', label: '抖音', href: '#' },
    { icon: 'ri-bilibili-line', label: 'B站', href: '#' },
  ];

  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-12 mb-12">
            <div className="lg:w-1/3">
              <Link to="/" className="inline-flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-emotion-happy-line text-xl text-background-50"></i>
                </div>
                <span className="font-heading text-2xl text-background-50">
                  51在线吃瓜
                </span>
              </Link>
              <p className="text-background-300 text-sm leading-relaxed mb-6">
                一站式娱乐资讯聚合平台，为您提供最新最全的明星八卦、网红爆料、社会热点追踪。51在线吃瓜入口，吃瓜群众的快乐源泉。
              </p>
              <div className="flex items-center gap-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    rel="nofollow"
                    className="w-10 h-10 flex items-center justify-center rounded-full border border-background-700 text-background-300 hover:text-background-50 hover:border-primary-500 transition-colors duration-200 cursor-pointer"
                    aria-label={social.label}
                  >
                    <i className={`${social.icon} text-lg`}></i>
                  </a>
                ))}
              </div>
            </div>

            <div className="lg:w-2/3 grid grid-cols-2 sm:grid-cols-3 gap-8">
              {footerLinks.map((group) => (
                <div key={group.title}>
                  <h4 className="text-background-50 font-medium text-sm mb-4">
                    {group.title}
                  </h4>
                  <div className="flex flex-col gap-2.5">
                    {group.links.map((link) => (
                      <Link
                        key={link.label}
                        to={link.to}
                        className="text-background-400 hover:text-background-50 text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="border-t border-background-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-6 text-background-500 text-xs">
              <span>&copy; 2026 51在线吃瓜 All Rights Reserved</span>
              <a href="#" className="hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
              <a href="#" className="hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">用户协议</a>
            </div>
            <div className="text-background-500 text-xs">
              51在线吃瓜入口 | 51吃瓜官网全网最新
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}